import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { RegisterDevtoolsEffects } from './effects/register-devtools.effects';
import { PcpDevtoolsService } from './pcp-devtools.service';

@NgModule({
    imports: [CommonModule, EffectsModule.forFeature([RegisterDevtoolsEffects])],
})
export class SharedDevtoolsFeatureShellModule {
    public static forRoot(): ModuleWithProviders<SharedDevtoolsFeatureShellModule> {
        return {
            ngModule: SharedDevtoolsFeatureShellModule,
            providers: [PcpDevtoolsService],
        };
    }
}
